export default {
  'pages.parking-management-fee.title': '车位管理费',
  'pages.parking-management-fee.subtitle':
    '管理车位管理费账单的生成、缴费和查询',
  'pages.parking-management-fee.tabOther': '其他',
  'pages.parking-management-fee.batch.create': '批量生成',
  'pages.parking-management-fee.batch.title': '批量生成车位管理费账单',
  'pages.parking-management-fee.batch.confirm': '确认生成',
  'pages.parking-management-fee.batch.cancel': '取消',
  'pages.parking-management-fee.batch.selectPeriodWarning': '请选择账期',
  'pages.parking-management-fee.batch.confirmTitle': '确认批量生成',
  'pages.parking-management-fee.batch.confirmContent':
    '确定要批量生成 {period} 的车位管理费账单吗？',
  'pages.parking-management-fee.batch.success': '成功生成 {count} 条账单',
  'pages.parking-management-fee.batch.failed': '批量生成失败',
  'pages.parking-management-fee.table.title': '车位管理费账单列表',
  'pages.parking-management-fee.columns.parking': '车位信息',
  'pages.parking-management-fee.columns.owner': '业主',
  'pages.parking-management-fee.columns.period': '账期',
  'pages.parking-management-fee.columns.billNo': '账单编号',
  'pages.parking-management-fee.columns.amount': '最终应付金额',
  'pages.parking-management-fee.columns.approval': '审核状态',
  'pages.parking-management-fee.columns.status': '缴费状态',
  'pages.parking-management-fee.columns.paymentAmount': '缴费金额',
  'pages.parking-management-fee.columns.paymentTime': '缴费时间',
  'pages.parking-management-fee.columns.dueAmount': '应缴',
  'pages.parking-management-fee.columns.actualAmount': '实缴',
  'pages.parking-management-fee.columns.operations': '操作',
  'pages.parking-management-fee.action.create': '新建账单',
  'pages.parking-management-fee.action.view': '查看',
  'pages.parking-management-fee.action.edit': '编辑',
  'pages.parking-management-fee.action.audit': '提交审核',
  'pages.parking-management-fee.action.batchDelete': '批量删除',
  'pages.parking-management-fee.form.createTitle': '新建车位管理费账单',
  'pages.parking-management-fee.form.editTitle': '编辑车位管理费账单',
  'pages.parking-management-fee.form.parking': '车位',
  'pages.parking-management-fee.form.selectParking': '请选择车位',
  'pages.parking-management-fee.form.select': '选择',
  'pages.parking-management-fee.form.priceConfig': '费用配置',
  'pages.parking-management-fee.form.period': '账期',
  'pages.parking-management-fee.form.amount': '金额',
  'pages.parking-management-fee.form.finalAmount': '最终应付金额',
  'pages.parking-management-fee.form.remarks': '备注',
  'pages.parking-management-fee.detail.title': '车位管理费账单详情',
  'pages.parking-management-fee.message.saveSuccess': '保存成功',
  'pages.parking-management-fee.message.saveFailed': '保存失败',
  'pages.parking-management-fee.message.detailFailed': '获取账单详情失败',
  'pages.parking-management-fee.message.deleteConfirm':
    '确定要删除这条账单吗？',
  'pages.parking-management-fee.message.deleteSuccess': '删除成功',
  'pages.parking-management-fee.message.deleteFailed': '删除失败',
  'pages.parking-management-fee.message.batchDeleteConfirm': '确认批量删除',
  'pages.parking-management-fee.message.batchDeleteContent':
    '确定删除选中的 {count} 条草稿或驳回账单吗？',
  'pages.parking-management-fee.message.batchDeleteDraftOnly':
    '只能删除草稿或已驳回的账单',
  'pages.parking-management-fee.message.selectAuditWarning':
    '请选择要提交审核的账单',
  'pages.parking-management-fee.message.auditConfirm':
    '确定提交选中的账单审核吗？',
  'pages.parking-management-fee.message.auditSuccess': '提交审核成功',
  'pages.parking-management-fee.message.auditFailed': '提交审核失败',
  'pages.parking-management-fee.detail.billNo': '账单编号',
  'pages.parking-management-fee.detail.parking': '车位',
  'pages.parking-management-fee.detail.owner': '业主',
  'pages.parking-management-fee.detail.period': '账期',
  'pages.parking-management-fee.detail.amount': '应付金额',
  'pages.parking-management-fee.detail.status': '缴费状态',
  'pages.parking-management-fee.detail.approval': '审核状态',
  'pages.parking-management-fee.detail.basicInfo': '基本信息',
  'pages.parking-management-fee.detail.paymentStatus': '缴费状态',
  'pages.parking-management-fee.detail.approvalStatus': '审核状态',
  'pages.parking-management-fee.detail.startDate': '开始日期',
  'pages.parking-management-fee.detail.endDate': '结束日期',
  'pages.parking-management-fee.detail.parkingOwnerInfo': '车位与业主信息',
  'pages.parking-management-fee.detail.parkingInfo': '车位信息',
  'pages.parking-management-fee.detail.ownerInfo': '业主信息',
  'pages.parking-management-fee.detail.ownerId': '业主ID',
  'pages.parking-management-fee.detail.ownerIdCard': '身份证',
  'pages.parking-management-fee.detail.ownerEmail': '邮箱',
  'pages.parking-management-fee.detail.amountInfo': '金额信息',
  'pages.parking-management-fee.detail.baseAmount': '基础金额',
  'pages.parking-management-fee.detail.lateFee': '滞纳金',
  'pages.parking-management-fee.detail.discountAmount': '优惠金额',
  'pages.parking-management-fee.detail.finalAmount': '最终金额',
  'pages.parking-management-fee.detail.paymentInfo': '缴费信息',
  'pages.parking-management-fee.detail.paymentMethod': '支付方式',
  'pages.parking-management-fee.detail.paymentReference': '支付凭证号',
  'pages.parking-management-fee.detail.systemInfo': '系统信息',
  'pages.parking-management-fee.detail.createdTime': '创建时间',
  'pages.parking-management-fee.detail.updatedTime': '更新时间',
  'pages.parking-management-fee.detail.dueDate': '到期日期',
  'pages.parking-management-fee.detail.paidDate': '缴费时间',
  'pages.parking-management-fee.detail.remarks': '备注',
  'pages.parking-management-fee.detail.auditRecords': '审核记录',
  'pages.parking-management-fee.detail.loading': '加载中...',
  'pages.parking-management-fee.detail.noRecords': '暂无审核记录',
  'pages.parking-management-fee.audit.title': '提交车位管理费审核',
  'pages.parking-management-fee.audit.name': '审核名称',
  'pages.parking-management-fee.audit.remark': '提交备注',
};
